import {
  IConversionTargetsData,
  IConverterFeaturesTableData,
  ILegendData,
} from "./types";

export const conversionTargetsData: IConversionTargetsData = {
  sketch: { icon: "SKETCH", label: "Sketch" },
  xd: { icon: "ADOBEXD", label: "XD" },
  figma: { icon: "FIGMA", label: "Figma" },
  psd: { icon: "PHOTOSHOP", label: "PSD" },
  ai: { icon: "AI", label: "Illustrator" },
  pdf: { icon: "PDF", label: "PDF" },
  googleslides: { icon: "GOOGLE-SLIDES", label: "Google Slides" },
  eps: { icon: "EPS_FILE", label: "EPS" },
  canva: { icon: "CANVA", label: "Canva" },
  indd: { icon: "INDESIGN", label: "InDesign" },
  powerpoint: { icon: "POWERPOINT", label: "PowerPoint" },
  website: { icon: "WEBSITE-ICON", label: "Website" },
};

export const converterFeaturesLegend: ILegendData = {
  full: { icon: "CHECK-ICON", label: "Full Support" },
  partial: { icon: "PARTIAL-ICON", label: "Partial Support" },
  unsupported: { icon: "ERROR-ICON", label: "Not Supported" },
  dev: { icon: "DEVELOPMENT-ICON", label: "In Development" },
  specific: { icon: "MINUS-ICON", label: "Tool Specific" },
};

export const data: IConverterFeaturesTableData = {
  xd: {
    converters: ["sketch", "figma", "psd"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Vector Paths": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Compound Paths": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Path Winding Rules": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Rounded Corners": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Preserve Native Shape Types": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "partial",
            tooltip:
              "All shapes will be converted to path elements in Photoshop.",
          },
        },
        Arc: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Linear Gradient Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Non-linear Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Angular Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Pattern Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Layer Blend Mode": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Strokes: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Advanced Stroke Settings": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Dashed Strokes": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Drop Shadow": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Background Blur": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "partial" },
        },
        "Layer Blur": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "unsupported",
            tooltip:
              "Layer blur can be achieved in Photoshop fundamentally different by applying layer masks. Due to the difference of Photoshop this is currently not supported by our converter.",
          },
        },
      },
      Components: {
        "Component Overrides": {
          sketch: {
            support: "partial",
            tooltip:
              "Sketch does not allow Component Instances to be overriden. Hence our converter is not able to leave component child instances attached to the parent. To preserve visual accuracy we detach the component. This way you still get 100% visually accurate results.",
          },
          figma: {
            support: "partial",
            tooltip:
              "Figma does not allow Component Instances to be overriden. Hence our converter is not able to leave component child instances attached to the parent. To preserve visual accuracy we detach the component. This way you still get 100% visually accurate results.",
          },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Component Variants": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "unsupported" },
        },
        "Component States": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Interactive Components": {
          sketch: {
            support: "specific",
            tooltip:
              "Sketch currently doesn't have a feature for interactive components.",
          },
          figma: { support: "dev" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Global Component Library": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
      },
      "Prototype Interaction": {
        Trigger: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
        },
        Action: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
        },
        Animation: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
        },
      },
      "Text & Color Styles": {
        "Character Style": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "unsupported" },
        },
        "Color Style": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "unsupported" },
        },
        "Layer Styles": {
          sketch: { support: "full" }, // TODO: incorrect support
          figma: { support: "full" }, // TODO: incorrect support
          psd: { support: "full" },
        },
        "Effect Styles": {
          sketch: { support: "full" }, // TODO: incorrect support
          figma: { support: "full" }, // TODO: incorrect support
          psd: { support: "full" },
        },
      },
      "Additional Features": {
        "Scroll Groups": {
          sketch: { support: "specific" },
          figma: { support: "specific" },
          psd: { support: "specific" },
        },
        "Layout Grids": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "specific" },
        },
        "Export Configurations": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "specific" },
        },
        Comments: {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "unsupported" },
        },
      },
      "Layout (e.g. Auto Layout)": {
        "Constraints & Resizing": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "partial" },
        },
        "Stack Direction": {
          sketch: {
            support: "specific",
            tooltip: "We convert Stack applied groups as normal groups.",
          },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "We convert Stack applied groups as normal groups.",
          },
        },
        "Padding & Spacing": {
          sketch: {
            support: "specific",
            tooltip:
              "We convert groups with applied Padding & Spacing as a normal groups.",
          },
          figma: {
            support: "specific",
            tooltip: "We convert Stack applied groups as normal groups.",
          },
          psd: {
            support: "specific",
            tooltip:
              "We convert groups with applied Padding & Spacing as a normal groups.",
          },
        },
        "Repeat Grids": {
          sketch: {
            support: "specific",
            tooltip: "We convert Repeat Groups as a normal groups",
          },
          figma: {
            support: "specific",
            tooltip: "We convert Repeat Groups as a normal groups",
          },
          psd: {
            support: "specific",
            tooltip: "We convert Repeat Groups as a normal groups",
          },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Transformation: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "3D Transform": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "unsupported" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "PDF Images": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Image Adjustments": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Text Frame Behaviour": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "OpenType support": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Emojis: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Lists/Bullet Points": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Line-height": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Paragraph Spacing": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Subscript + Superscript": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Different text styles in one element": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Strikethrough: {
          sketch: { support: "full" }, // TODO: incorrect support
          figma: { support: "full" }, // TODO: incorrect support
          psd: { support: "full" }, // TODO: incorrect support
        },
      },
    },
  },
  sketch: {
    converters: ["xd", "figma", "psd"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Vector Paths": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Compound Paths": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Path Winding Rules": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Rounded Corners": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Preserve Native Shape Types": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "partial",
            tooltip:
              "All shapes will be converted to path elements in Photoshop.",
          },
        },
        Arc: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Linear Gradient Fills": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Non-linear Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Angular Gradient": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Pattern Fills": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Layer Blend Mode": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Strokes: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Advanced Stroke Settings": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Dashed Strokes": {
          xd: { support: "full" }, // TODO: incorrect support
          figma: { support: "full" }, // TODO: incorrect support
          psd: { support: "full" }, // TODO: incorrect support
        },
        Opacity: {
          xd: { support: "full" }, // TODO: incorrect support
          figma: { support: "full" }, // TODO: incorrect support
          psd: { support: "full" }, // TODO: incorrect support
        },
      },
      Effects: {
        "Inner Shadow": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Drop Shadow": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Background Blur": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "partial",
            tooltip:
              "Layer blur can be achieved in Photoshop fundamentally different by applying layer masks. Due to the difference of Photoshop this is currently not supported by our converter.",
          },
        },
        "Layer Blur": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "unsupported" },
        },
      },
      Components: {
        "Component Overrides": {
          xd: { support: "partial" },
          figma: { support: "partial" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Component Variants": {
          xd: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Component States": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Interactive Components": {
          xd: { support: "specific" },
          figma: { support: "dev" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Global Component Library": {
          xd: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
        },
      },
      "Prototype Interaction": {
        Trigger: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
        },
        Action: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
        },
        Animation: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
        },
      },
      "Text & Color Styles": {
        "Character Style": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "unsupported" },
        },
        "Color Style": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "unsupported" },
        },
        "Layer Styles": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Effect Styles": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      "Additional Features": {
        "Scroll Groups": {
          xd: { support: "specific" },
          figma: { support: "specific" },
          psd: { support: "specific" },
        },
        "Layout Grids": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "specific" },
        },
        "Export Configurations": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "specific" },
        },
        Comments: {
          xd: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "unsupported" },
        },
      },
      "Layout (e.g. Auto Layout)": {
        "Constraints & Resizing": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Transformation: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "PDF Images": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Image Adjustments": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Text Frame Behaviour": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "OpenType support": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Emojis: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Lists/Bullet Points": {
          xd: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "unsupported" },
        },
        "Line-height": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Paragraph Spacing": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Subscript + Superscript": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        "Different text styles in one element": {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
        Strikethrough: {
          xd: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
        },
      },
    },
  },
  figma: {
    converters: ["sketch", "xd", "psd", "powerpoint", "canva"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Vector Paths": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Compound Paths": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Path Winding Rules": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Rounded Corners": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "dev" },
        },
        "Preserve Native Shape Types": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: {
            support: "partial",
            tooltip:
              "All shapes will be converted to path elements in Photoshop.",
          },
          powerpoint: { support: "full" },
          canva: { support: "partial" },
        },
        Arc: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Linear Gradient Fills": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Non-linear Gradient": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Angular Gradient": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Pattern Fills": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Layer Blend Mode": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        Strokes: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Advanced Stroke Settings": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Dashed Strokes": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        Opacity: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Drop Shadow": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Background Blur": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "partial" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Layer Blur": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "partial" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
      },
      Components: {
        "Component Overrides": {
          sketch: { support: "partial" },
          xd: { support: "partial" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
          powerpoint: {
            support: "specific",
            tooltip:
              "PowerPoint does not support Components, our converter creates the underlying basic shapes.",
          },
          canva: {
            support: "specific",
            tooltip:
              "Canva does not support Components, our converter creates the underlying basic shapes.",
          },
        },
        "Component Variants": {
          sketch: { support: "unsupported" },
          xd: { support: "unsupported" },
          psd: { support: "unsupported" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Component States": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Interactive Components": {
          sketch: { support: "specific" },
          xd: { support: "dev" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" }, // TODO: what is the support
        },
        "Global Component Library": {
          sketch: { support: "unsupported" },
          xd: { support: "unsupported" },
          psd: {
            support: "specific",
            tooltip:
              "Photoshop does not support Components, our converter creates the underlying basic shapes.",
          },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
      },
      "Prototype Interaction": {
        Trigger: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        Action: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        Animation: {
          sketch: { support: "unsupported" },
          xd: { support: "unsupported" },
          psd: {
            support: "specific",
            tooltip: "Photoshop does not support Prototype.",
          },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
      },
      "Text & Color Styles": {
        "Character Style": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "unsupported" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Color Style": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "unsupported" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Layer Styles": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
        "Effect Styles": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
      },
      "Additional Features": {
        "Layout Grids": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "specific" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "Export Configurations": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "specific" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        Comments: {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "unsupported" },
          powerpoint: { support: "unsupported" },
          canva: { support: "unsupported" },
        },
      },
      "Layout (e.g. Auto Layout)": {
        "Constraints & Resizing": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "partial" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "Auto Layout": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
          psd: { support: "specific" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "Alignment & Padding": {
          sketch: {
            support: "specific", // TODO: what is support?
            tooltip: "We Alignment & Padding applied group as a normal group.",
          },
          figma: {
            support: "specific", // TODO: what is support?
            tooltip: "We Alignment & Padding applied group as a normal group.",
          },
          psd: {
            support: "specific", // TODO: what is support?
            tooltip: "We Alignment & Padding applied group as a normal group.",
          },
          powerpoint: {
            support: "specific", // TODO: what is support?
            tooltip: "We Alignment & Padding applied group as a normal group.",
          },
          canva: {
            support: "specific", // TODO: what is support?
            tooltip: "We Alignment & Padding applied group as a normal group.",
          },
        },
        "Spacing between items": {
          sketch: { support: "specific" },
          figma: { support: "specific" },
          psd: { support: "specific" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        Transformation: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "3D Transform": {
          sketch: { support: "unsupported" },
          xd: { support: "unsupported" },
          psd: { support: "unsupported" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        Opacity: {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "PDF Images": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Image Adjustments": {
          sketch: { support: "full" },
          xd: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
      },
      Text: {
        "Text Layers": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Text Frame Behaviour": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "Text Positioning for Custom Fonts": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "OpenType support": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        Emojis: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "Lists/Bullet Points": {
          sketch: { support: "specific" },
          figma: { support: "specific" },
          psd: { support: "specific" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        "Line-height": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Paragraph Spacing": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Subscript + Superscript": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "full" },
          canva: { support: "full" },
        },
        "Different text styles in one element": {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
        Strikethrough: {
          sketch: { support: "full" },
          figma: { support: "full" },
          psd: { support: "full" },
          powerpoint: { support: "specific" },
          canva: { support: "specific" },
        },
      },
    },
  },
  psd: {
    converters: ["sketch", "figma"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Vector Paths": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Compound Paths": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Path Winding Rules": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Rounded Corners": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Preserve Native Shape Types": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Arc: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Linear Gradient Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Non-linear Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Angular Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Pattern Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Layer Blend Mode": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Strokes: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Advanced Stroke Settings": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Dashed Strokes": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Drop Shadow": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Feather: {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
        "Inner Glow": {
          sketch: {
            support: "partial",
            tooltip:
              "Since inner glow is not available in Figma, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
          figma: {
            support: "partial",
            tooltip:
              "Since inner glow is not available in Sketch, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
        },
        "Outer Glow": {
          sketch: {
            support: "partial",
            tooltip:
              "Since outer glow is not a Figma feature, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
          figma: {
            support: "partial",
            tooltip:
              "Since outer glow is not available in Figma, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
        },
        "Bevel & Emboss": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
        Warp: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Smart Filters": {
          sketch: {
            support: "full", // TODO: what is the support?
            tooltip:
              "We convert Smart Filter applied layers as rasterized layers",
          },
          figma: {
            support: "full", // TODO: what is the support?
            tooltip:
              "We convert Smart Filter applied layers as rasterized layers",
          },
        },
      },
      "Text & Color Styles": {
        "Character Style": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
        "Paragraph Style": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Transformation: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "PDF Images": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Image Adjustments": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "OpenType support": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Emojis: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Lists/Bullet Points": {
          sketch: { support: "specific" },
          figma: { support: "specific" },
        },
        "Line-height": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Paragraph Spacing": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Subscript + Superscript": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Different text styles in one element": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Strikethrough: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      "Additional Feature": {
        "3D": {
          sketch: {
            support: "full",
            tooltip: "We convert 3D applied layers as a raster image",
          },
          figma: {
            support: "full",
            tooltip: "We convert 3D applied layers as a raster image",
          },
        },
      },
    },
  },
  ai: {
    converters: ["figma", "sketch"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Vector Paths": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Compound Paths": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Path Winding Rules": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Rounded Corners": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Preserve Native Shape Types": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Arc: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Linear Gradient Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Non-linear Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Angular Gradient": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Pattern Fills": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Layer Blend Mode": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Strokes: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Advanced Stroke Settings": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Dashed Strokes": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Drop Shadow": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Feather: {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
        "Inner Glow": {
          sketch: {
            support: "partial",
            tooltip:
              "Since inner glow is not available in Sketch, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
          figma: {
            support: "partial",
            tooltip:
              "Since inner glow is not available in Figma, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
        },
        "Outer Glow": {
          sketch: {
            support: "partial",
            tooltip:
              "Since outer glow is not available in Figma, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
          figma: {
            support: "partial",
            tooltip:
              "Since outer glow is not a Figma feature, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
        },
        Scribble: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Warp: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      "Text & Color Styles": {
        "Character Style": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
        "Paragraph Style": {
          sketch: { support: "unsupported" },
          figma: { support: "unsupported" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Transformation: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Opacity: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "PDF Images": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Image Adjustments": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "OpenType support": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Emojis: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Lists/Bullet Points": {
          sketch: { support: "specific" },
          figma: { support: "specific" },
        },
        "Line-height": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Paragraph Spacing": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Subscript + Superscript": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        "Different text styles in one element": {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
        Strikethrough: {
          sketch: { support: "full" },
          figma: { support: "full" },
        },
      },
      "Additional Feature": {
        "3D and Materials": {
          sketch: {
            support: "full",
            tooltip:
              "We convert 3D and Materials applied layers as a raster image",
          },
          figma: {
            support: "full",
            tooltip:
              "We convert 3D and Materials applied layers as a raster image",
          },
        },
      },
    },
  },
  pdf: {
    converters: ["figma", "sketch", "psd", "xd"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Vector Paths": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Compound Paths": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Path Winding Rules": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Rounded Corners": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Preserve Native Shape Types": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        Arc: {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Linear Gradient Fills": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Non-linear Gradient": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Angular Gradient": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Pattern Fills": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Layer Blend Mode": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        Strokes: {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Advanced Stroke Settings": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Dashed Strokes": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        "Drop Shadow": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" },
          xd: { support: "full" },
        },
        Feather: {
          figma: { support: "unsupported" },
          sketch: { support: "unsupported" },
          psd: { support: "unsupported" },
          xd: { support: "unsupported" },
        },
        "Inner Glow": {
          figma: { support: "unsupported" },
          sketch: { support: "unsupported" },
          psd: { support: "unsupported" },
          xd: { support: "unsupported" },
        },
        "Outer Glow": {
          figma: { support: "unsupported" },
          sketch: { support: "unsupported" },
          psd: { support: "unsupported" },
          xd: { support: "unsupported" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        Transformation: {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "PDF Images": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "Image Adjustments": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "OpenType support": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        Emojis: {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "Lists/Bullet Points": {
          figma: { support: "specific" },
          sketch: { support: "specific" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "specific" },
        },
        "Line-height": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "Paragraph Spacing": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        "Subscript + Superscript": {
          figma: { support: "unsupported" },
          sketch: { support: "unsupported" },
          psd: { support: "unsupported" }, // TODO: what is support
          xd: { support: "unsupported" },
        },
        "Different text styles in one element": {
          figma: { support: "full" },
          sketch: { support: "full" },
          psd: { support: "full" }, // TODO: what is support
          xd: { support: "full" },
        },
        Strikethrough: {
          figma: { support: "partial" },
          sketch: { support: "partial" },
          psd: { support: "partial" }, // TODO: what is support
          xd: { support: "partial" },
        },
      },
    },
  },
  googleslides: {
    converters: ["figma"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          figma: { support: "full" },
        },
        "Vector Paths": {
          figma: { support: "full" },
        },
        "Compound Paths": {
          figma: { support: "full" },
        },
        "Path Winding Rules": {
          figma: { support: "full" },
        },
        "Rounded Corners": {
          figma: { support: "full" },
        },
        "Preserve Native Shape Types": {
          figma: { support: "full" },
        },
        Arc: {
          figma: { support: "full" },
        },
        Scribble: {
          figma: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          figma: { support: "full" },
        },
        "Linear Gradient Fills": {
          figma: { support: "full" },
        },
        "Non-linear Gradient": {
          figma: { support: "full" },
        },
        "Angular Gradient": {
          figma: { support: "full" },
        },
        Strokes: {
          figma: { support: "full" },
        },
        "Advanced Stroke Settings": {
          figma: { support: "full" },
        },
        "Dashed Strokes": {
          figma: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          figma: { support: "full" },
        },
        "Drop Shadow": {
          figma: { support: "full" },
        },
        Reflection: {
          figma: { support: "partial" },
        },
      },
      "Layer Properties": {
        Transformation: {
          figma: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          figma: { support: "full" },
        },
        "PDF Images": {
          figma: { support: "full" },
        },
        "Image Adjustments": {
          figma: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          figma: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          figma: { support: "full" },
        },
        "OpenType support": {
          figma: { support: "full" },
        },
        Emojis: {
          figma: { support: "full" },
        },
        "Lists/Bullet Points": {
          figma: { support: "specific" },
        },
        "Line-height": {
          figma: { support: "full" },
        },
        "Paragraph Spacing": {
          figma: { support: "full" },
        },
        "Subscript + Superscript": {
          figma: { support: "full" },
        },
        "Different text styles in one element": {
          figma: { support: "full" },
        },
        Strikethrough: {
          figma: { support: "full" },
        },
      },
    },
  },
  eps: {
    converters: ["figma"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          figma: { support: "full" },
        },
        "Vector Paths": {
          figma: { support: "full" },
        },
        "Compound Paths": {
          figma: { support: "full" },
        },
        "Path Winding Rules": {
          figma: { support: "full" },
        },
        "Rounded Corners": {
          figma: { support: "full" },
        },
        "Preserve Native Shape Types": {
          figma: { support: "full" },
        },
        Arc: {
          figma: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          figma: { support: "full" },
        },
        "Linear Gradient Fills": {
          figma: { support: "full" },
        },
        "Non-linear Gradient": {
          figma: { support: "full" },
        },
        "Angular Gradient": {
          figma: { support: "full" },
        },
        "Pattern Fills": {
          figma: { support: "full" },
        },
        "Layer Blend Mode": {
          figma: { support: "full" },
        },
        Strokes: {
          figma: { support: "full" },
        },
        "Advanced Stroke Settings": {
          figma: { support: "full" },
        },
        "Dashed Strokes": {
          figma: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          figma: { support: "full" },
        },
        "Drop Shadow": {
          figma: { support: "full" },
        },
        Feather: {
          figma: { support: "unsupported" },
        },
        "Inner Glow": {
          figma: {
            support: "partial",
            tooltip:
              "Since inner glow is not available in Figma, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
        },
        "Outer Glow": {
          figma: {
            support: "partial",
            tooltip:
              "Since outer glow is not a Figma fature, we create an addition layer for each inner glow and make it mask to keep same visual appearance",
          },
        },
        Scribble: {
          figma: { support: "full" },
        },
        Warp: {
          figma: { support: "full" },
        },
      },
      "Text & Color Styles": {
        "Character Style": {
          figma: { support: "unsupported" },
        },
        "Paragraph Style": {
          figma: { support: "unsupported" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          figma: { support: "full" },
        },
        Transformation: {
          figma: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          figma: { support: "full" },
        },
        "PDF Images": {
          figma: { support: "full" },
        },
        "Image Adjustments": {
          figma: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          figma: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          figma: { support: "full" },
        },
        "OpenType support": {
          figma: { support: "full" },
        },
        Emojis: {
          figma: { support: "full" },
        },
        "Lists/Bullet Points": {
          figma: { support: "specific" },
        },
        "Line-height": {
          figma: { support: "full" },
        },
        "Paragraph Spacing": {
          figma: { support: "full" },
        },
        "Subscript + Superscript": {
          figma: { support: "full" },
        },
        "Different text styles in one element": {
          figma: { support: "full" },
        },
        Strikethrough: {
          figma: { support: "full" },
        },
      },
      "Additional Feature": {
        "3D and Materials": {
          figma: {
            support: "full",
            tooltip:
              "We convert 3D and Materials applied layers as a raster image",
          },
        },
      },
    },
  },
  indd: {
    converters: ["figma"],
    data: {
      "Basic Shapes": {
        "Rectangle, Circle, ...": {
          figma: { support: "full" },
        },
        "Vector Paths": {
          figma: { support: "full" },
        },
        "Compound Paths": {
          figma: { support: "full" },
        },
        "Path Winding Rules": {
          figma: { support: "full" },
        },
        "Rounded Corners": {
          figma: { support: "full" },
        },
        "Preserve Native Shape Types": {
          figma: { support: "full" },
        },
        Arc: {
          figma: { support: "full" },
        },
      },
      Appearance: {
        "Solid Fills": {
          figma: { support: "full" },
        },
        "Linear Gradient Fills": {
          figma: { support: "full" },
        },
        "Non-linear Gradient": {
          figma: { support: "full" },
        },
        "Angular Gradient": {
          figma: { support: "full" },
        },
        "Pattern Fills": {
          figma: { support: "full" },
        },
        "Layer Blend Mode": {
          figma: { support: "full" },
        },
        Strokes: {
          figma: { support: "full" },
        },
        "Advanced Stroke Settings": {
          figma: { support: "full" },
        },
        "Dashed Strokes": {
          figma: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
        },
      },
      Effects: {
        "Inner Shadow": {
          figma: { support: "full" },
        },
        "Drop Shadow": {
          figma: { support: "full" },
        },
        Feather: {
          figma: { support: "unsupported" },
        },
        "Inner Glow": {
          figma: { support: "unsupported" },
        },
        "Outer Glow": {
          figma: { support: "unsupported" },
        },
      },
      "Layer Properties": {
        "Layer Mask": {
          figma: { support: "full" },
        },
        Transformation: {
          figma: { support: "full" },
        },
        Opacity: {
          figma: { support: "full" },
        },
      },
      Images: {
        "Bitmap Images": {
          figma: { support: "full" },
        },
        "PDF Images": {
          figma: { support: "full" },
        },
        "Image Adjustments": {
          figma: { support: "full" },
        },
      },
      Text: {
        "Text Layers": {
          figma: { support: "full" },
        },
        "Text Positioning for Custom Fonts": {
          figma: { support: "full" },
        },
        "OpenType support": {
          figma: { support: "full" },
        },
        Emojis: {
          figma: { support: "full" },
        },
        "Lists/Bullet Points": {
          figma: { support: "specific" },
        },
        "Line-height": {
          figma: { support: "full" },
        },
        "Paragraph Spacing": {
          figma: { support: "full" },
        },
        "Subscript + Superscript": {
          figma: { support: "unsupported" },
        },
        "Different text styles in one element": {
          figma: { support: "full" },
        },
        Strikethrough: {
          figma: { support: "partial" },
        },
      },
    },
  },
};
